document.addEventListener('change', function(event) {
  var checkbox = event.target;
  if (!checkbox || !checkbox.matches('[data-express-checkout]')) return;

  var variantId = checkbox.getAttribute('data-variant-id');
  var quantity = parseInt(checkbox.getAttribute('data-quantity') || '1', 10);

  if (!variantId || quantity <= 0) {
    checkbox.checked = false;
    return;
  }

  function postForm(url, params, onDone, onError) {
    var body = new URLSearchParams();
    Object.keys(params).forEach(function(k) {
      body.append(k, params[k]);
    });

    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        if (onDone) onDone(xhr.responseText);
      } else {
        if (onError) onError(xhr);
      }
    };
    xhr.send(body.toString());
  }

  function addToCart(id, qty, onDone, onError) {
    postForm(
      '/cart/add.js',
      { id: String(id), quantity: String(qty) },
      onDone,
      onError
    );
  }

  function setVariantQty(id, qty, onDone, onError) {
    var key = 'updates[' + String(id) + ']';
    var params = {};
    params[key] = String(qty);

    postForm(
      '/cart/update.js',
      params,
      onDone,
      onError
    );
  }

  if (checkbox.checked) {
    var allExpress = Array.prototype.slice.call(document.querySelectorAll('[data-express-checkout]'));
    var toRemove = [];

    allExpress.forEach(function(cb) {
      if (!cb || cb === checkbox) return;
      var otherId = cb.getAttribute('data-variant-id');
      if (!otherId) return;
      if (String(otherId) === String(variantId)) return;
      cb.checked = false;
      toRemove.push(String(otherId));
    });

    function removeNext(i) {
      if (i >= toRemove.length) {
        addToCart(
          variantId,
          quantity,
          function() { window.location.reload(); },
          function() { checkbox.checked = false; }
        );
        return;
      }

      setVariantQty(
        toRemove[i],
        0,
        function() { removeNext(i + 1); },
        function() { removeNext(i + 1); }
      );
    }

    removeNext(0);
    return;
  }

  setVariantQty(
    variantId,
    0,
    function() { window.location.reload(); },
    function() { checkbox.checked = true; }
  );
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.seExpressInCart) {
    function disableZapietAndUnlockCheckout() {
      var selectors = ['#storePickupApp', '#zapiet-checkout-methods', '.zapiet-widget-wrapper'];
      selectors.forEach(function(sel) {
        var els = document.querySelectorAll(sel);
        els.forEach(function(el) {
          el.style.display = 'none';
        });
      });

      var checkoutBtn = document.querySelector('input[name="checkout"]');
      if (!checkoutBtn) return;

      var clone = checkoutBtn.cloneNode(true);
      clone.removeAttribute('data-zapiet-checkout-button');
      if (checkoutBtn.id) clone.id = checkoutBtn.id;
      clone.disabled = checkoutBtn.disabled;

      if (checkoutBtn.parentNode) checkoutBtn.parentNode.replaceChild(clone, checkoutBtn);
    }

    disableZapietAndUnlockCheckout();
    setTimeout(disableZapietAndUnlockCheckout, 500);
    setTimeout(disableZapietAndUnlockCheckout, 1500);
  }

  var hcAgreementPP = document.querySelector('#agreement');
  if (!hcAgreementPP) return;

  hcAgreementPP.addEventListener('change', function(e) {
    var checkoutBtn = document.querySelector("[name='checkout']");
    if (!checkoutBtn) return;
    if (e.target && e.target.checked) {
      checkoutBtn.removeAttribute('disabled');
    } else {
      checkoutBtn.setAttribute('disabled', true);
    }
  });
});